export default __webpack_public_path__ + "static/media/pic6.d9f8224e.jpg";